import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '1. O que é uma licitação pública?',
      answer: 'Licitação é o processo que o governo usa para comprar produtos ou contratar serviços de empresas privadas. É uma forma de garantir transparência, concorrência justa e melhor uso do dinheiro público.',
      isList: false
    },
    {
      question: '2. Quem pode participar de uma licitação?',
      answer: 'Qualquer empresa que esteja regularizada e com a documentação em dia pode participar. Basta atender às exigências do edital e se cadastrar na plataforma usada pelo órgão público, como Compras.gov.br, BLL ou Licitanet, por exemplo.',
      isList: false
    },
    {
      question: '3. Preciso ter uma empresa grande para participar?',
      answer: 'Não! Micro e pequenas empresas também podem participar e têm benefícios garantidos por lei, como preferência em caso de empate e participação exclusiva em licitações de menor valor (Lei Complementar nº 123/2006).',
      isList: false
    },
    {
      question: '4. O que é um edital de licitação?',
      answer: 'O edital é o "manual da licitação". Ele contém todas as regras, prazos, documentos necessários, critérios de julgamento e detalhes do objeto que o órgão público quer contratar. Ler o edital com atenção é o primeiro passo para participar com segurança.',
      isList: false
    },
    {
      question: '5. Quais são os tipos mais comuns de licitação?',
      answer: 'Os principais são:',
      isList: true,
      listItems: [
        'Pregão Eletrônico: o mais usado, para compras e serviços comuns.',
        'Concorrência: usada em obras e contratos de maior valor.',
        'Dispensa de Licitação: quando o valor é pequeno ou há urgência (contratação direta).'
      ]
    },
    {
      question: '6. O que é um pregão eletrônico?',
      answer: 'É a licitação feita pela internet, onde as empresas enviam propostas e dão lances ao vivo para oferecer o menor preço. É rápida, segura e a mais utilizada atualmente pela administração pública.',
      isList: false
    },
    {
      question: '7. Quais documentos preciso para participar de uma licitação?',
      answer: 'Geralmente, são exigidos:',
      isList: true,
      listItems: [
        'CNPJ ativo e contrato social;',
        'Certidões fiscais e trabalhistas negativas;',
        'Certificado do FGTS e INSS;',
        'Atestados técnicos, se exigidos;',
        'Proposta comercial e planilha de preços.',
        'Esses documentos comprovam que a empresa é idônea, regular e capaz de cumprir o contrato.'
      ]
    },
    {
      question: '8. É difícil vender para o governo?',
      answer: 'Não é difícil, mas exige organização e atenção às regras. Com orientação correta e documentação em ordem, qualquer empresa pode vender para o setor público, inclusive iniciantes no mercado.',
      isList: false
    },
    {
      question: '9. O governo paga em dia?',
      answer: 'Sim, normalmente o pagamento ocorre após o recebimento e aceitação do produto ou serviço, dentro do prazo previsto no edital ou contrato. Alguns órgãos pagam em até 30 dias, contados da entrega e emissão da nota fiscal.',
      isList: false
    },
    {
      question: '10. Quais são as vantagens de participar de licitações?',
      answer: '',
      isList: true,
      listItems: [
        'Clientes seguros (o governo sempre compra e paga via orçamento público);',
        'Previsibilidade de receita com contratos de médio e longo prazo;',
        'Oportunidade de crescimento e ampliação de mercado;',
        'Valorização da imagem da empresa pela atuação com ética e transparência.'
      ]
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-lg text-text-grey max-w-3xl mx-auto">
            Tire suas dúvidas sobre licitações públicas e como a LicitMax pode ajudar sua empresa.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-light-grey rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-panel-${index}`}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-white/50 transition-colors duration-300"
              >
                <h3 className="text-lg font-semibold text-primary pr-8">
                  {faq.question}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    aria-hidden="true"
                    className={`ri-arrow-down-s-line text-2xl text-primary transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>

              <div
                id={`faq-panel-${index}`}
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[600px]' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  {faq.answer && (
                    <p className="text-text-grey leading-relaxed mb-3">
                      {faq.answer}
                    </p>
                  )}
                  {faq.isList && faq.listItems && (
                    <ul className="list-disc list-inside space-y-2 text-text-grey leading-relaxed">
                      {faq.listItems.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-text-grey mb-6">
            Ainda tem dúvidas? Fale com nossos especialistas.
          </p>
          <a
            href="https://wa.me/5544999957005"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-4 bg-accent text-primary font-semibold rounded-lg hover:bg-accent/90 hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            Falar com Especialista
          </a>
        </div>
      </div>
    </section>
  );
}
